import React from "react";
import ModalWrapper from "./ModalWrapper";

import AddDataSource from "../AddDataSource";

export default function AddDataSourceModal({
	open,
	dataSourceId,
	onClose,
	closeable,
}) {
	return (
		<ModalWrapper open={open} onClose={onClose} closeable={closeable}>
			<AddDataSource />
		</ModalWrapper>
	);
}
